import { render, staticRenderFns } from "./Prefix.vue?vue&type=template&id=8a20ee98&scoped=true"
import script from "./Prefix.vue?vue&type=script&lang=js"
export * from "./Prefix.vue?vue&type=script&lang=js"
import style0 from "./Prefix.vue?vue&type=style&index=0&id=8a20ee98&prod&lang=css"
import style1 from "./Prefix.vue?vue&type=style&index=1&id=8a20ee98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a20ee98",
  null
  
)

export default component.exports